let clientWidth = document.documentElement.clientWidth;

function CalibratedSize(blueprintSize, newClientWidth = clientWidth, anchorWidth = 1920) {
	return blueprintSize * (newClientWidth / anchorWidth);
}
 
export default CalibratedSize;